import React from 'react';
import { usePage } from '@inertiajs/react';
import JMSLogo from "@Assets/images/Logo/jms-logo-blue.png";

function LogoLogin(props: { branding: string}) {
  const { branding } = props;
  const { url } = usePage();

  const isRepsol = branding === "REPSOL";
  const isAlinta = branding === "ALINTA";
  const isJMS = branding === "JMS";
  const isPrivacyPolicy = url === '/privacy-policy';

  const logoHeight = isRepsol ? 250 : (isAlinta || isJMS) ? undefined : 130;

  const logoSrc = (isJMS && isPrivacyPolicy && import.meta.env.VITE_HEADER_LOGO)
    ? import.meta.env.VITE_HEADER_LOGO
    : (import.meta.env.VITE_LOGIN_SCREEN_LOGO || JMSLogo);

  return (
    <div className={`text-center my-0 ${isJMS ? 'md:my-2' : 'md:my-6'}`}>
      <img
        src={logoSrc}
        alt="JMS"
        height={logoHeight}
        style={{
          maxWidth: isAlinta || isRepsol || isJMS ? '70%' : '35%',
          objectFit: 'contain',
          width: 'auto'
        }}
      />
    </div>
  );
}

export default LogoLogin;
